<template>
  <!-- similar 图搜 -->
  <template v-if="type === 'similar'">
    <H5ImageSearch v-if="isMobile" />
    <ImageSearch v-else />
  </template>
  <!-- 文搜 -->
  <TextSearch
    v-if="(categoryId || keyword)"
  />
</template>

<script setup>
import { useRoute } from 'vue-router'
import { H5ImageSearch } from './H5ImageSearch'
import { ImageSearch } from './ImageSearch'
import { TextSearch } from './TextSearch'
import { isMobile } from '@/utils/constants'

const route = useRoute()

const keyword = computed(() => route.query.keyword)
const categoryId = computed(() => route.query.categoryId)
const type = computed(() => route.query.type)
</script>

<style scoped lang="less">
@import "./index.less";
</style>
